import { createAction, handleActions } from 'redux-actions'

const setFilters = createAction('SCREENS/RAMSSIGNINGS/SET_FILTERS')

const defaultState = {
  status: 'All',
}

const reducer = handleActions(
  {
    [setFilters]: (state, action) => ({ ...state, ...action.payload }),
  },
  defaultState,
)

export { setFilters, reducer }
